import installRouter from '@Framework/installRouter';
import { Vue } from 'vue-property-decorator';
export default (store) => {
    const router = installRouter(Vue, {
        mode: 'hash'
    });
    return router;
};
